export default "__VITE_ASSET__Dm0nAmEp__";